import * as yup from 'yup';

export const detailsSchema = yup.object().shape({
	type: yup.string(),
	size: yup.string().required('Tank size is required.'),
	contractor: yup.string().required('Contractor is required'),
	permit: yup.string(),
	parcelNumber: yup
		.string()
		.required('Parcel number is required.')
		.matches(/[0-9]{2}:[0-9]{3}:[0-9]{4}/g, 'Invalid parcel number'),
	//.test('len', 'Invalid Parcel Number Length (must be 9 digits long)', val => val.length === 9),
});
